// ==============================|| OVERRIDES - SELECT ||============================== //

export default function Select(theme) {
  return {
    MuiSelect: {
      styleOverrides: {
        root: {
          '&::placeholder': {
            color: theme.palette.text.disabled,
            opacity: 1,
          },
        },
        select: {
          lineHeight: '1.250rem',
          minHeight: 'auto',
          '& .MuiTypography-root.MuiTypography-body1': {
            lineHeight: '1.250rem',
          },
        },
        nativeInput: {
          '&::placeholder': {
            color: theme.palette.text.disabled,
            opacity: 1,
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        color: theme.palette.text.secondary,
        backgroundColor: theme.palette.secondary.light,
        lineHeight: '1.250rem',
        root: {
          '&:hover': {
            backgroundColor: theme.palette.secondary.dark,
            color: theme.palette.text.primary,
          },
          '&.Mui-selected': {
            color: theme.palette.text.primary,
            backgroundColor: 'transparent',
            borderLeft: `3px solid ${theme.palette.primary.darker}`,
            '&:hover': {
              backgroundColor: theme.palette.secondary.dark,
            },
          },
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          border: `1px solid ${theme.palette.secondary.darker}`,
          color: theme.palette.text.secondary,
          boxShadow: theme.customShadows.inputShadow,
        },
      },
    },
  }
}
